import { InfiniteScroll, IInfiniteScroll } from "./InfiniteScroll"

export type { IInfiniteScroll };
export default InfiniteScroll;
